module.exports = __webpack_public_path__ + "static/img/2nie.d2ce80c1.webp";